export default __webpack_public_path__ + "static/assets/7c84e8643c80cfc44c3dafbdbcb04c1b.svg";